import { httpClient } from '../http-client';
import { Holiday } from './types';

export const holidaysService = () => {
  const client = httpClient();
  const BASE_URL = '/v1/holidays';

  return {
    fetchHolidays: async (terminal: string): Promise<Holiday[] | null> => {
      const url = `${BASE_URL}/${terminal}`;
      try {
        const result = await client.get<Holiday[]>(url);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
    createHoliday: async (data: Holiday): Promise<Holiday | null> => {
      try {
        const result = await client.post<Holiday>(BASE_URL, data);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
    updateHoliday: async (data: Holiday): Promise<Holiday | null> => {
      const url = `${BASE_URL}/${data.id}`;
      try {
        const result = await client.put<Holiday>(url, data);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
    deleteHoliday: async (id: number): Promise<{} | null> => {
      const url = `${BASE_URL}/${id}`;
      try {
        const result = await client.delete<{}>(url);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
  };
};

const logger = (message: string): void => console.error(`[Holidays Service] ${message}`);
